import {
  getAcquisitionOffers,
  getCalculateHasSolarPanels,
  getConsumptionValuesVM,
  getFeatureFlags,
  getFunnelSettings,
  getSupplyAddressVM,
  isGetOffersLoading,
} from '@innogy/become-a-customer/state';
import { hasMemberGetMember } from '@innogy/shared/member-get-member';
import { createSelector } from '@ngrx/store';

export const acquisitionCommodityOfferVM = createSelector(
  getAcquisitionOffers,
  getConsumptionValuesVM,
  getSupplyAddressVM,
  getFunnelSettings,
  hasMemberGetMember,
  isGetOffersLoading,
  getCalculateHasSolarPanels,
  getFeatureFlags('crossSellThuisvoordeelAddon'),
  (
    offers,
    consumption,
    address,
    funnelSettings,
    member,
    isLoading,
    hasSolarPanels,
    crossSellThuisvoordeelAddon
  ) => ({
    offers,
    consumption,
    address,
    funnelSettings,
    hasMemberGetMember: member,
    isLoading,
    hasSolarPanels,
    crossSellThuisvoordeelAddon,
  })
);
